module.exports = __webpack_public_path__ + "media/malik.751467f4.mp4";